import { capi } from "..";
import { ScoringSimulateLtvDTOin } from "./DTOs/scoringSimulateLtvDTOin";
import { ScoringSimulateLtvDTOout } from "./DTOs/scoringSimulateLtvDTOout";

export const scoringSimulateLtv = (scoringSimulateLtvDTOin: ScoringSimulateLtvDTOin): Promise<ScoringSimulateLtvDTOout> => {
    return capi.post('/v1/scoring/simulate', scoringSimulateLtvDTOin);
}